// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/persona/persona.proto" (package "base.persona", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DoubleValue } from "../../google/protobuf/wrappers";
import { Int64Value } from "../../google/protobuf/wrappers";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.persona.GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest
 */
export interface GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message base.persona.GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse
 */
export interface GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetAllInsoleCustomDataRequest
 */
export interface GetAllInsoleCustomDataRequest {
}
/**
 * @generated from protobuf message base.persona.GetAllInsoleCustomDataResponse
 */
export interface GetAllInsoleCustomDataResponse {
    /**
     * @generated from protobuf field: repeated base.persona.InsoleCustomData insoleCustomData = 1
     */
    insoleCustomData: InsoleCustomData[];
}
/**
 * @generated from protobuf message base.persona.GetAccountsInsoleCustomDataRequest
 */
export interface GetAccountsInsoleCustomDataRequest {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetAccountsInsoleCustomDataResponse
 */
export interface GetAccountsInsoleCustomDataResponse {
    /**
     * @generated from protobuf field: repeated base.persona.GetAccountsInsoleCustomDataResponse.InsoleCustomDataListForAccounts insoleCustomData = 1
     */
    insoleCustomData: GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts[];
}
/**
 * @generated from protobuf message base.persona.GetAccountsInsoleCustomDataResponse.InsoleCustomDataListForAccounts
 */
export interface GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: repeated base.persona.InsoleCustomData insoleCustomData = 2
     */
    insoleCustomData: InsoleCustomData[];
}
/**
 * @generated from protobuf message base.persona.UpdateInsoleCustomShippingRequest
 */
export interface UpdateInsoleCustomShippingRequest {
    /**
     * @generated from protobuf field: int64 insoleCustomDataId = 1
     */
    insoleCustomDataId: string;
    /**
     * @generated from protobuf field: base.persona.ShippingStatus shippingStatus = 2
     */
    shippingStatus: ShippingStatus;
}
/**
 * @generated from protobuf message base.persona.UpdateInsoleCustomShippingResponse
 */
export interface UpdateInsoleCustomShippingResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.persona.GetInsoleCustomDataListRequest
 */
export interface GetInsoleCustomDataListRequest {
}
/**
 * @generated from protobuf message base.persona.GetInsoleCustomDataListResponse
 */
export interface GetInsoleCustomDataListResponse {
    /**
     * @generated from protobuf field: repeated base.persona.InsoleCustomData insoleCustomData = 1
     */
    insoleCustomData: InsoleCustomData[];
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateInsoleCustomDataRequest
 */
export interface CreateOrUpdateInsoleCustomDataRequest {
    /**
     * @generated from protobuf field: base.persona.InsoleCustomData insoleCustomData = 1
     */
    insoleCustomData?: InsoleCustomData;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateInsoleCustomDataResponse
 */
export interface CreateOrUpdateInsoleCustomDataResponse {
    /**
     * @generated from protobuf field: int64 insoleCustomDataId = 1
     */
    insoleCustomDataId: string;
}
/**
 * @generated from protobuf message base.persona.InsoleCustomData
 */
export interface InsoleCustomData {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string age = 2
     */
    age: string;
    /**
     * @generated from protobuf field: float shoeSize = 3
     */
    shoeSize: number;
    /**
     * @generated from protobuf field: string height = 4
     */
    height: string;
    /**
     * @generated from protobuf field: string weight = 5
     */
    weight: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue backAndFloatMedia = 6
     */
    backAndFloatMedia?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue squatMedia = 7
     */
    squatMedia?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footBackViewData = 8
     */
    footBackViewData?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footVerticalViewMedia = 9
     */
    footVerticalViewMedia?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue archFigureMediaLeft = 10
     */
    archFigureMediaLeft?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue archFigureMediaRight = 11
     */
    archFigureMediaRight?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footFigureMedia = 12
     */
    footFigureMedia?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footLengthRight = 13
     */
    footLengthRight?: StringValue;
    /**
     * @generated from protobuf field: base.persona.OrderStatus orderStatus = 14
     */
    orderStatus: OrderStatus;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value insoleCustomDataId = 15
     */
    insoleCustomDataId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footWidthRight = 16
     */
    footWidthRight?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footHeightRight = 17
     */
    footHeightRight?: StringValue;
    /**
     * @generated from protobuf field: base.persona.ShippingStatus shippingStatus = 18
     */
    shippingStatus: ShippingStatus;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 19
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footLengthLeft = 20
     */
    footLengthLeft?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footWidthLeft = 21
     */
    footWidthLeft?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue footHeightLeft = 22
     */
    footHeightLeft?: StringValue;
    /**
     * @generated from protobuf field: int64 createTimestamp = 23
     */
    createTimestamp: string;
}
/**
 * @generated from protobuf message base.persona.GetAllPersonaRequest
 */
export interface GetAllPersonaRequest {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetAllPersonaResponse
 */
export interface GetAllPersonaResponse {
    /**
     * @generated from protobuf field: repeated base.persona.AllPersona allPersona = 1
     */
    allPersona: AllPersona[];
}
/**
 * @generated from protobuf message base.persona.AllPersona
 */
export interface AllPersona {
    /**
     * @generated from protobuf field: int64 accountId = 2
     */
    accountId: string;
    /**
     * @generated from protobuf field: base.persona.BodyInfo bodyInfoResult = 4
     */
    bodyInfoResult?: BodyInfo;
    /**
     * @generated from protobuf field: base.persona.SocialInfo socialResult = 6
     */
    socialResult?: SocialInfo;
    /**
     * @generated from protobuf field: base.persona.ContactInfo contactInfoResult = 8
     */
    contactInfoResult?: ContactInfo;
    /**
     * @generated from protobuf field: base.persona.WorkInfo workInfoResult = 10
     */
    workInfoResult?: WorkInfo;
    /**
     * @generated from protobuf field: base.persona.IntrinsicInfo intrinsicInfoResult = 12
     */
    intrinsicInfoResult?: IntrinsicInfo;
}
/**
 * @generated from protobuf message base.persona.CreateBodyByAccessTokenRequest
 */
export interface CreateBodyByAccessTokenRequest {
    /**
     * @generated from protobuf field: base.persona.CreateBodyByAccessToken bodyInfo = 1
     */
    bodyInfo?: CreateBodyByAccessToken;
}
/**
 * @generated from protobuf message base.persona.CreateBodyByAccessToken
 */
export interface CreateBodyByAccessToken {
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightScalar = 2
     */
    heightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightUnit = 3
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightScalar = 4
     */
    weightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightUnit = 5
     */
    weightUnit?: StringValue;
}
/**
 * @generated from protobuf message base.persona.CreateBodyByAccessTokenResponse
 */
export interface CreateBodyByAccessTokenResponse {
    /**
     * @generated from protobuf field: int64 bodyId = 1
     */
    bodyId: string;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateIntrinsicByAccessTokenRequest
 */
export interface CreateOrUpdateIntrinsicByAccessTokenRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value birthdate = 2
     */
    birthdate?: Int64Value;
    /**
     * @generated from protobuf field: base.persona.Gender gender = 3
     */
    gender: Gender;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateIntrinsicByAccessTokenResponse
 */
export interface CreateOrUpdateIntrinsicByAccessTokenResponse {
    /**
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateContactByAccessTokenRequest
 */
export interface CreateOrUpdateContactByAccessTokenRequest {
    /**
     * 职业
     *
     * @generated from protobuf field: google.protobuf.StringValue mobileNumber = 2
     */
    mobileNumber?: StringValue;
    /**
     * 收入
     *
     * @generated from protobuf field: google.protobuf.Int64Value address = 3
     */
    address?: Int64Value;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateContactByAccessTokenResponse
 */
export interface CreateOrUpdateContactByAccessTokenResponse {
    /**
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateWorkByAccessTokenRequest
 */
export interface CreateOrUpdateWorkByAccessTokenRequest {
    /**
     * 职业
     *
     * @generated from protobuf field: google.protobuf.StringValue profession = 2
     */
    profession?: StringValue;
    /**
     * 收入
     *
     * @generated from protobuf field: google.protobuf.DoubleValue income = 3
     */
    income?: DoubleValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue resume = 4
     */
    resume?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue signature = 5
     */
    signature?: StringValue;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateWorkByAccessTokenResponse
 */
export interface CreateOrUpdateWorkByAccessTokenResponse {
    /**
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateSocialByAccessTokenRequest
 */
export interface CreateOrUpdateSocialByAccessTokenRequest {
    /**
     * 头像
     *
     * @generated from protobuf field: google.protobuf.StringValue avatar = 2
     */
    avatar?: StringValue;
    /**
     * 真实姓名
     *
     * @generated from protobuf field: google.protobuf.StringValue realName = 3
     */
    realName?: StringValue;
    /**
     * 显示姓名
     *
     * @generated from protobuf field: google.protobuf.StringValue displayName = 4
     */
    displayName?: StringValue;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateSocialByAccessTokenResponse
 */
export interface CreateOrUpdateSocialByAccessTokenResponse {
    /**
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.GetIntrinsicRequest
 */
export interface GetIntrinsicRequest {
}
/**
 * @generated from protobuf message base.persona.GetIntrinsicResponse
 */
export interface GetIntrinsicResponse {
    /**
     * @generated from protobuf field: base.persona.IntrinsicInfo intrinsicInfoResult = 1
     */
    intrinsicInfoResult?: IntrinsicInfo;
}
/**
 * @generated from protobuf message base.persona.GetWorkRequest
 */
export interface GetWorkRequest {
}
/**
 * @generated from protobuf message base.persona.GetWorkResponse
 */
export interface GetWorkResponse {
    /**
     * @generated from protobuf field: base.persona.WorkInfo workInfoResult = 1
     */
    workInfoResult?: WorkInfo;
}
/**
 * @generated from protobuf message base.persona.GetContactRequest
 */
export interface GetContactRequest {
}
/**
 * @generated from protobuf message base.persona.GetContactResponse
 */
export interface GetContactResponse {
    /**
     * @generated from protobuf field: base.persona.ContactInfo contactInfoResult = 1
     */
    contactInfoResult?: ContactInfo;
}
/**
 * @generated from protobuf message base.persona.GetSocialRequest
 */
export interface GetSocialRequest {
}
/**
 * @generated from protobuf message base.persona.GetSocialResponse
 */
export interface GetSocialResponse {
    /**
     * @generated from protobuf field: base.persona.SocialInfo socialResult = 1
     */
    socialResult?: SocialInfo;
}
/**
 * @generated from protobuf message base.persona.GetBodyRequest
 */
export interface GetBodyRequest {
}
/**
 * @generated from protobuf message base.persona.GetBodyResponse
 */
export interface GetBodyResponse {
    /**
     * @generated from protobuf field: base.persona.BodyInfo bodyInfoResult = 1
     */
    bodyInfoResult?: BodyInfo;
}
/**
 * @generated from protobuf message base.persona.SocialInfo
 */
export interface SocialInfo {
    /**
     * 账号id
     *
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * 头像
     *
     * @generated from protobuf field: google.protobuf.StringValue avatar = 2
     */
    avatar?: StringValue;
    /**
     * 真实姓名
     *
     * @generated from protobuf field: google.protobuf.StringValue realName = 3
     */
    realName?: StringValue;
    /**
     * 显示姓名
     *
     * @generated from protobuf field: google.protobuf.StringValue displayName = 4
     */
    displayName?: StringValue;
}
/**
 * @generated from protobuf message base.persona.CreateSocialRequest
 */
export interface CreateSocialRequest {
    /**
     * @generated from protobuf field: base.persona.SocialInfo socialInfo = 1
     */
    socialInfo?: SocialInfo;
}
/**
 * @generated from protobuf message base.persona.CreateSocialResponse
 */
export interface CreateSocialResponse {
    /**
     * 社会属性id
     *
     * @generated from protobuf field: int64 socialId = 1
     */
    socialId: string;
}
/**
 * @generated from protobuf message base.persona.UpdateSocialRequest
 */
export interface UpdateSocialRequest {
    /**
     * @generated from protobuf field: base.persona.SocialInfo socialInfo = 1
     */
    socialInfo?: SocialInfo;
}
/**
 * @generated from protobuf message base.persona.UpdateSocialResponse
 */
export interface UpdateSocialResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.persona.DeleteSocialRequest
 */
export interface DeleteSocialRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.persona.DeleteSocialResponse
 */
export interface DeleteSocialResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.persona.GetSocialByAccountIdsRequest
 */
export interface GetSocialByAccountIdsRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetSocialByAccountIdsResponse
 */
export interface GetSocialByAccountIdsResponse {
    /**
     * @generated from protobuf field: repeated base.persona.SocialInfo socialResults = 1
     */
    socialResults: SocialInfo[];
}
/**
 * @generated from protobuf message base.persona.WorkInfo
 */
export interface WorkInfo {
    /**
     * 账号id
     *
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * 职业
     *
     * @generated from protobuf field: google.protobuf.StringValue profession = 2
     */
    profession?: StringValue;
    /**
     * 收入
     *
     * @generated from protobuf field: google.protobuf.DoubleValue income = 3
     */
    income?: DoubleValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue resume = 4
     */
    resume?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue signature = 5
     */
    signature?: StringValue;
}
/**
 * @generated from protobuf message base.persona.CreateWorkRequest
 */
export interface CreateWorkRequest {
    /**
     * @generated from protobuf field: base.persona.WorkInfo workInfo = 1
     */
    workInfo?: WorkInfo;
}
/**
 * @generated from protobuf message base.persona.CreateWorkResponse
 */
export interface CreateWorkResponse {
    /**
     * 社会属性id
     *
     * @generated from protobuf field: int64 workId = 1
     */
    workId: string;
}
/**
 * @generated from protobuf message base.persona.UpdateWorkRequest
 */
export interface UpdateWorkRequest {
    /**
     * @generated from protobuf field: base.persona.WorkInfo workInfo = 1
     */
    workInfo?: WorkInfo;
}
/**
 * @generated from protobuf message base.persona.UpdateWorkResponse
 */
export interface UpdateWorkResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.persona.GetWorkByAccountIdsRequest
 */
export interface GetWorkByAccountIdsRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetWorkByAccountIdsResponse
 */
export interface GetWorkByAccountIdsResponse {
    /**
     * @generated from protobuf field: repeated base.persona.WorkInfo workInfoResults = 1
     */
    workInfoResults: WorkInfo[];
}
/**
 * @generated from protobuf message base.persona.ContactInfo
 */
export interface ContactInfo {
    /**
     * 账号id
     *
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * 职业
     *
     * @generated from protobuf field: google.protobuf.StringValue mobileNumber = 2
     */
    mobileNumber?: StringValue;
    /**
     * 收入
     *
     * @generated from protobuf field: google.protobuf.Int64Value address = 3
     */
    address?: Int64Value;
}
/**
 * @generated from protobuf message base.persona.CreateContactRequest
 */
export interface CreateContactRequest {
    /**
     * @generated from protobuf field: base.persona.ContactInfo contactInfo = 1
     */
    contactInfo?: ContactInfo;
}
/**
 * @generated from protobuf message base.persona.CreateContactResponse
 */
export interface CreateContactResponse {
    /**
     * 联系id
     *
     * @generated from protobuf field: int64 contactId = 1
     */
    contactId: string;
}
/**
 * @generated from protobuf message base.persona.UpdateContactRequest
 */
export interface UpdateContactRequest {
    /**
     * @generated from protobuf field: base.persona.ContactInfo contactInfo = 1
     */
    contactInfo?: ContactInfo;
}
/**
 * @generated from protobuf message base.persona.UpdateContactResponse
 */
export interface UpdateContactResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.persona.GetContactByAccountIdsRequest
 */
export interface GetContactByAccountIdsRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetContactByAccountIdsResponse
 */
export interface GetContactByAccountIdsResponse {
    /**
     * @generated from protobuf field: repeated base.persona.ContactInfo contactInfoResults = 1
     */
    contactInfoResults: ContactInfo[];
}
/**
 * @generated from protobuf message base.persona.BodyInfo
 */
export interface BodyInfo {
    /**
     * 账号id
     *
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightScalar = 2
     */
    heightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue heightUnit = 3
     */
    heightUnit?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightScalar = 4
     */
    weightScalar?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue weightUnit = 5
     */
    weightUnit?: StringValue;
}
/**
 * @generated from protobuf message base.persona.CreateBodyRequest
 */
export interface CreateBodyRequest {
    /**
     * @generated from protobuf field: base.persona.BodyInfo bodyInfo = 1
     */
    bodyInfo?: BodyInfo;
}
/**
 * @generated from protobuf message base.persona.CreateBodyResponse
 */
export interface CreateBodyResponse {
    /**
     * 联系id
     *
     * @generated from protobuf field: int64 bodyId = 1
     */
    bodyId: string;
}
/**
 * @generated from protobuf message base.persona.GetBodyByAccountIdsRequest
 */
export interface GetBodyByAccountIdsRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetBodyByAccountIdsResponse
 */
export interface GetBodyByAccountIdsResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: repeated base.persona.BodyInfo bodyInfoResults = 1
     */
    bodyInfoResults: BodyInfo[];
}
/**
 * @generated from protobuf message base.persona.IntrinsicInfo
 */
export interface IntrinsicInfo {
    /**
     * 账号id
     *
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value birthdate = 2
     */
    birthdate?: Int64Value;
    /**
     * @generated from protobuf field: base.persona.Gender gender = 3
     */
    gender: Gender;
}
/**
 * @generated from protobuf message base.persona.CreateIntrinsicRequest
 */
export interface CreateIntrinsicRequest {
    /**
     * @generated from protobuf field: base.persona.IntrinsicInfo intrinsicInfo = 1
     */
    intrinsicInfo?: IntrinsicInfo;
}
/**
 * @generated from protobuf message base.persona.CreateIntrinsicResponse
 */
export interface CreateIntrinsicResponse {
    /**
     * 联系id
     *
     * @generated from protobuf field: int64 IntrinsicId = 1
     */
    intrinsicId: string;
}
/**
 * @generated from protobuf message base.persona.UpdateIntrinsicRequest
 */
export interface UpdateIntrinsicRequest {
    /**
     * @generated from protobuf field: base.persona.IntrinsicInfo intrinsicInfo = 1
     */
    intrinsicInfo?: IntrinsicInfo;
}
/**
 * @generated from protobuf message base.persona.UpdateIntrinsicResponse
 */
export interface UpdateIntrinsicResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.persona.GetIntrinsicByAccountIdsRequest
 */
export interface GetIntrinsicByAccountIdsRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetIntrinsicByAccountIdsResponse
 */
export interface GetIntrinsicByAccountIdsResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: repeated base.persona.IntrinsicInfo intrinsicInfoResults = 1
     */
    intrinsicInfoResults: IntrinsicInfo[];
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateIntrinsicRequest
 */
export interface CreateOrUpdateIntrinsicRequest {
    /**
     * @generated from protobuf field: base.persona.IntrinsicInfo intrinsicInfo = 1
     */
    intrinsicInfo?: IntrinsicInfo;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateIntrinsicResponse
 */
export interface CreateOrUpdateIntrinsicResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateContactRequest
 */
export interface CreateOrUpdateContactRequest {
    /**
     * @generated from protobuf field: base.persona.ContactInfo contactInfo = 1
     */
    contactInfo?: ContactInfo;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateContactResponse
 */
export interface CreateOrUpdateContactResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateWorkRequest
 */
export interface CreateOrUpdateWorkRequest {
    /**
     * @generated from protobuf field: base.persona.WorkInfo workInfo = 1
     */
    workInfo?: WorkInfo;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateWorkResponse
 */
export interface CreateOrUpdateWorkResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateSocialRequest
 */
export interface CreateOrUpdateSocialRequest {
    /**
     * @generated from protobuf field: base.persona.SocialInfo socialInfo = 1
     */
    socialInfo?: SocialInfo;
}
/**
 * @generated from protobuf message base.persona.CreateOrUpdateSocialResponse
 */
export interface CreateOrUpdateSocialResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: bool isFinished = 1
     */
    isFinished: boolean;
}
/**
 * @generated from protobuf message base.persona.GetBodyListByAccountIdsRequest
 */
export interface GetBodyListByAccountIdsRequest {
    /**
     * 账号id
     *
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.persona.GetBodyListByAccountIdsResponse
 */
export interface GetBodyListByAccountIdsResponse {
    /**
     * 是否修改成功
     *
     * @generated from protobuf field: repeated base.persona.BodyInfo bodyInfoResults = 1
     */
    bodyInfoResults: BodyInfo[];
}
/**
 * @generated from protobuf message base.persona.GetPresignedPutObjectUrlRequest
 */
export interface GetPresignedPutObjectUrlRequest {
    /**
     * @generated from protobuf field: string object_type = 1
     */
    objectType: string;
    /**
     * @generated from protobuf field: string key = 2
     */
    key: string;
}
/**
 * @generated from protobuf message base.persona.GetPresignedPutObjectUrlResponse
 */
export interface GetPresignedPutObjectUrlResponse {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string url = 2
     */
    url: string;
}
/**
 * @generated from protobuf enum base.persona.ShippingStatus
 */
export enum ShippingStatus {
    /**
     * @generated from protobuf enum value: NOT_SHIPPING = 0;
     */
    NOT_SHIPPING = 0,
    /**
     * @generated from protobuf enum value: HAS_SHIPPING = 1;
     */
    HAS_SHIPPING = 1
}
/**
 * @generated from protobuf enum base.persona.OrderStatus
 */
export enum OrderStatus {
    /**
     * @generated from protobuf enum value: HAS_CUSTOM = 0;
     */
    HAS_CUSTOM = 0,
    /**
     * @generated from protobuf enum value: NOT_CUSTOM = 1;
     */
    NOT_CUSTOM = 1
}
/**
 * @generated from protobuf enum base.persona.Gender
 */
export enum Gender {
    /**
     * @generated from protobuf enum value: MALE = 0;
     */
    MALE = 0,
    /**
     * @generated from protobuf enum value: FEMALE = 1;
     */
    FEMALE = 1,
    /**
     * @generated from protobuf enum value: UNKNOWN = 2;
     */
    UNKNOWN = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest$Type extends MessageType<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest> {
    constructor() {
        super("base.persona.GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest>): GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest): GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest
 */
export const GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest = new GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse$Type extends MessageType<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse> {
    constructor() {
        super("base.persona.GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse>): GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse): GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse
 */
export const GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse = new GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllInsoleCustomDataRequest$Type extends MessageType<GetAllInsoleCustomDataRequest> {
    constructor() {
        super("base.persona.GetAllInsoleCustomDataRequest", []);
    }
    create(value?: PartialMessage<GetAllInsoleCustomDataRequest>): GetAllInsoleCustomDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllInsoleCustomDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllInsoleCustomDataRequest): GetAllInsoleCustomDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllInsoleCustomDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAllInsoleCustomDataRequest
 */
export const GetAllInsoleCustomDataRequest = new GetAllInsoleCustomDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllInsoleCustomDataResponse$Type extends MessageType<GetAllInsoleCustomDataResponse> {
    constructor() {
        super("base.persona.GetAllInsoleCustomDataResponse", [
            { no: 1, name: "insoleCustomData", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InsoleCustomData }
        ]);
    }
    create(value?: PartialMessage<GetAllInsoleCustomDataResponse>): GetAllInsoleCustomDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.insoleCustomData = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllInsoleCustomDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllInsoleCustomDataResponse): GetAllInsoleCustomDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.InsoleCustomData insoleCustomData */ 1:
                    message.insoleCustomData.push(InsoleCustomData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllInsoleCustomDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.InsoleCustomData insoleCustomData = 1; */
        for (let i = 0; i < message.insoleCustomData.length; i++)
            InsoleCustomData.internalBinaryWrite(message.insoleCustomData[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAllInsoleCustomDataResponse
 */
export const GetAllInsoleCustomDataResponse = new GetAllInsoleCustomDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountsInsoleCustomDataRequest$Type extends MessageType<GetAccountsInsoleCustomDataRequest> {
    constructor() {
        super("base.persona.GetAccountsInsoleCustomDataRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountsInsoleCustomDataRequest>): GetAccountsInsoleCustomDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountsInsoleCustomDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountsInsoleCustomDataRequest): GetAccountsInsoleCustomDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountsInsoleCustomDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAccountsInsoleCustomDataRequest
 */
export const GetAccountsInsoleCustomDataRequest = new GetAccountsInsoleCustomDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountsInsoleCustomDataResponse$Type extends MessageType<GetAccountsInsoleCustomDataResponse> {
    constructor() {
        super("base.persona.GetAccountsInsoleCustomDataResponse", [
            { no: 1, name: "insoleCustomData", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts }
        ]);
    }
    create(value?: PartialMessage<GetAccountsInsoleCustomDataResponse>): GetAccountsInsoleCustomDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.insoleCustomData = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountsInsoleCustomDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountsInsoleCustomDataResponse): GetAccountsInsoleCustomDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.GetAccountsInsoleCustomDataResponse.InsoleCustomDataListForAccounts insoleCustomData */ 1:
                    message.insoleCustomData.push(GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountsInsoleCustomDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.GetAccountsInsoleCustomDataResponse.InsoleCustomDataListForAccounts insoleCustomData = 1; */
        for (let i = 0; i < message.insoleCustomData.length; i++)
            GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts.internalBinaryWrite(message.insoleCustomData[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAccountsInsoleCustomDataResponse
 */
export const GetAccountsInsoleCustomDataResponse = new GetAccountsInsoleCustomDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts$Type extends MessageType<GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts> {
    constructor() {
        super("base.persona.GetAccountsInsoleCustomDataResponse.InsoleCustomDataListForAccounts", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "insoleCustomData", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InsoleCustomData }
        ]);
    }
    create(value?: PartialMessage<GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts>): GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.insoleCustomData = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts): GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* repeated base.persona.InsoleCustomData insoleCustomData */ 2:
                    message.insoleCustomData.push(InsoleCustomData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* repeated base.persona.InsoleCustomData insoleCustomData = 2; */
        for (let i = 0; i < message.insoleCustomData.length; i++)
            InsoleCustomData.internalBinaryWrite(message.insoleCustomData[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAccountsInsoleCustomDataResponse.InsoleCustomDataListForAccounts
 */
export const GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts = new GetAccountsInsoleCustomDataResponse_InsoleCustomDataListForAccounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateInsoleCustomShippingRequest$Type extends MessageType<UpdateInsoleCustomShippingRequest> {
    constructor() {
        super("base.persona.UpdateInsoleCustomShippingRequest", [
            { no: 1, name: "insoleCustomDataId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "shippingStatus", kind: "enum", T: () => ["base.persona.ShippingStatus", ShippingStatus] }
        ]);
    }
    create(value?: PartialMessage<UpdateInsoleCustomShippingRequest>): UpdateInsoleCustomShippingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.insoleCustomDataId = "0";
        message.shippingStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateInsoleCustomShippingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateInsoleCustomShippingRequest): UpdateInsoleCustomShippingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 insoleCustomDataId */ 1:
                    message.insoleCustomDataId = reader.int64().toString();
                    break;
                case /* base.persona.ShippingStatus shippingStatus */ 2:
                    message.shippingStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateInsoleCustomShippingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 insoleCustomDataId = 1; */
        if (message.insoleCustomDataId !== "0")
            writer.tag(1, WireType.Varint).int64(message.insoleCustomDataId);
        /* base.persona.ShippingStatus shippingStatus = 2; */
        if (message.shippingStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.shippingStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateInsoleCustomShippingRequest
 */
export const UpdateInsoleCustomShippingRequest = new UpdateInsoleCustomShippingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateInsoleCustomShippingResponse$Type extends MessageType<UpdateInsoleCustomShippingResponse> {
    constructor() {
        super("base.persona.UpdateInsoleCustomShippingResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateInsoleCustomShippingResponse>): UpdateInsoleCustomShippingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateInsoleCustomShippingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateInsoleCustomShippingResponse): UpdateInsoleCustomShippingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateInsoleCustomShippingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateInsoleCustomShippingResponse
 */
export const UpdateInsoleCustomShippingResponse = new UpdateInsoleCustomShippingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInsoleCustomDataListRequest$Type extends MessageType<GetInsoleCustomDataListRequest> {
    constructor() {
        super("base.persona.GetInsoleCustomDataListRequest", []);
    }
    create(value?: PartialMessage<GetInsoleCustomDataListRequest>): GetInsoleCustomDataListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetInsoleCustomDataListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInsoleCustomDataListRequest): GetInsoleCustomDataListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInsoleCustomDataListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetInsoleCustomDataListRequest
 */
export const GetInsoleCustomDataListRequest = new GetInsoleCustomDataListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInsoleCustomDataListResponse$Type extends MessageType<GetInsoleCustomDataListResponse> {
    constructor() {
        super("base.persona.GetInsoleCustomDataListResponse", [
            { no: 1, name: "insoleCustomData", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InsoleCustomData }
        ]);
    }
    create(value?: PartialMessage<GetInsoleCustomDataListResponse>): GetInsoleCustomDataListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.insoleCustomData = [];
        if (value !== undefined)
            reflectionMergePartial<GetInsoleCustomDataListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetInsoleCustomDataListResponse): GetInsoleCustomDataListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.InsoleCustomData insoleCustomData */ 1:
                    message.insoleCustomData.push(InsoleCustomData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetInsoleCustomDataListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.InsoleCustomData insoleCustomData = 1; */
        for (let i = 0; i < message.insoleCustomData.length; i++)
            InsoleCustomData.internalBinaryWrite(message.insoleCustomData[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetInsoleCustomDataListResponse
 */
export const GetInsoleCustomDataListResponse = new GetInsoleCustomDataListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateInsoleCustomDataRequest$Type extends MessageType<CreateOrUpdateInsoleCustomDataRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateInsoleCustomDataRequest", [
            { no: 1, name: "insoleCustomData", kind: "message", T: () => InsoleCustomData }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateInsoleCustomDataRequest>): CreateOrUpdateInsoleCustomDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateInsoleCustomDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateInsoleCustomDataRequest): CreateOrUpdateInsoleCustomDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.InsoleCustomData insoleCustomData */ 1:
                    message.insoleCustomData = InsoleCustomData.internalBinaryRead(reader, reader.uint32(), options, message.insoleCustomData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateInsoleCustomDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.InsoleCustomData insoleCustomData = 1; */
        if (message.insoleCustomData)
            InsoleCustomData.internalBinaryWrite(message.insoleCustomData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateInsoleCustomDataRequest
 */
export const CreateOrUpdateInsoleCustomDataRequest = new CreateOrUpdateInsoleCustomDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateInsoleCustomDataResponse$Type extends MessageType<CreateOrUpdateInsoleCustomDataResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateInsoleCustomDataResponse", [
            { no: 1, name: "insoleCustomDataId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateInsoleCustomDataResponse>): CreateOrUpdateInsoleCustomDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.insoleCustomDataId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateInsoleCustomDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateInsoleCustomDataResponse): CreateOrUpdateInsoleCustomDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 insoleCustomDataId */ 1:
                    message.insoleCustomDataId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateInsoleCustomDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 insoleCustomDataId = 1; */
        if (message.insoleCustomDataId !== "0")
            writer.tag(1, WireType.Varint).int64(message.insoleCustomDataId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateInsoleCustomDataResponse
 */
export const CreateOrUpdateInsoleCustomDataResponse = new CreateOrUpdateInsoleCustomDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InsoleCustomData$Type extends MessageType<InsoleCustomData> {
    constructor() {
        super("base.persona.InsoleCustomData", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "age", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "shoeSize", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "height", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "weight", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "backAndFloatMedia", kind: "message", T: () => StringValue },
            { no: 7, name: "squatMedia", kind: "message", T: () => StringValue },
            { no: 8, name: "footBackViewData", kind: "message", T: () => StringValue },
            { no: 9, name: "footVerticalViewMedia", kind: "message", T: () => StringValue },
            { no: 10, name: "archFigureMediaLeft", kind: "message", T: () => StringValue },
            { no: 11, name: "archFigureMediaRight", kind: "message", T: () => StringValue },
            { no: 12, name: "footFigureMedia", kind: "message", T: () => StringValue },
            { no: 13, name: "footLengthRight", kind: "message", T: () => StringValue },
            { no: 14, name: "orderStatus", kind: "enum", T: () => ["base.persona.OrderStatus", OrderStatus] },
            { no: 15, name: "insoleCustomDataId", kind: "message", T: () => Int64Value },
            { no: 16, name: "footWidthRight", kind: "message", T: () => StringValue },
            { no: 17, name: "footHeightRight", kind: "message", T: () => StringValue },
            { no: 18, name: "shippingStatus", kind: "enum", T: () => ["base.persona.ShippingStatus", ShippingStatus] },
            { no: 19, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 20, name: "footLengthLeft", kind: "message", T: () => StringValue },
            { no: 21, name: "footWidthLeft", kind: "message", T: () => StringValue },
            { no: 22, name: "footHeightLeft", kind: "message", T: () => StringValue },
            { no: 23, name: "createTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<InsoleCustomData>): InsoleCustomData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.age = "";
        message.shoeSize = 0;
        message.height = "";
        message.weight = "";
        message.orderStatus = 0;
        message.shippingStatus = 0;
        message.createTimestamp = "0";
        if (value !== undefined)
            reflectionMergePartial<InsoleCustomData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InsoleCustomData): InsoleCustomData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string age */ 2:
                    message.age = reader.string();
                    break;
                case /* float shoeSize */ 3:
                    message.shoeSize = reader.float();
                    break;
                case /* string height */ 4:
                    message.height = reader.string();
                    break;
                case /* string weight */ 5:
                    message.weight = reader.string();
                    break;
                case /* google.protobuf.StringValue backAndFloatMedia */ 6:
                    message.backAndFloatMedia = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.backAndFloatMedia);
                    break;
                case /* google.protobuf.StringValue squatMedia */ 7:
                    message.squatMedia = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.squatMedia);
                    break;
                case /* google.protobuf.StringValue footBackViewData */ 8:
                    message.footBackViewData = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footBackViewData);
                    break;
                case /* google.protobuf.StringValue footVerticalViewMedia */ 9:
                    message.footVerticalViewMedia = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footVerticalViewMedia);
                    break;
                case /* google.protobuf.StringValue archFigureMediaLeft */ 10:
                    message.archFigureMediaLeft = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.archFigureMediaLeft);
                    break;
                case /* google.protobuf.StringValue archFigureMediaRight */ 11:
                    message.archFigureMediaRight = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.archFigureMediaRight);
                    break;
                case /* google.protobuf.StringValue footFigureMedia */ 12:
                    message.footFigureMedia = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footFigureMedia);
                    break;
                case /* google.protobuf.StringValue footLengthRight */ 13:
                    message.footLengthRight = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footLengthRight);
                    break;
                case /* base.persona.OrderStatus orderStatus */ 14:
                    message.orderStatus = reader.int32();
                    break;
                case /* google.protobuf.Int64Value insoleCustomDataId */ 15:
                    message.insoleCustomDataId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.insoleCustomDataId);
                    break;
                case /* google.protobuf.StringValue footWidthRight */ 16:
                    message.footWidthRight = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footWidthRight);
                    break;
                case /* google.protobuf.StringValue footHeightRight */ 17:
                    message.footHeightRight = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footHeightRight);
                    break;
                case /* base.persona.ShippingStatus shippingStatus */ 18:
                    message.shippingStatus = reader.int32();
                    break;
                case /* google.protobuf.Int64Value accountId */ 19:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.StringValue footLengthLeft */ 20:
                    message.footLengthLeft = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footLengthLeft);
                    break;
                case /* google.protobuf.StringValue footWidthLeft */ 21:
                    message.footWidthLeft = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footWidthLeft);
                    break;
                case /* google.protobuf.StringValue footHeightLeft */ 22:
                    message.footHeightLeft = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.footHeightLeft);
                    break;
                case /* int64 createTimestamp */ 23:
                    message.createTimestamp = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InsoleCustomData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string age = 2; */
        if (message.age !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.age);
        /* float shoeSize = 3; */
        if (message.shoeSize !== 0)
            writer.tag(3, WireType.Bit32).float(message.shoeSize);
        /* string height = 4; */
        if (message.height !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.height);
        /* string weight = 5; */
        if (message.weight !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.weight);
        /* google.protobuf.StringValue backAndFloatMedia = 6; */
        if (message.backAndFloatMedia)
            StringValue.internalBinaryWrite(message.backAndFloatMedia, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue squatMedia = 7; */
        if (message.squatMedia)
            StringValue.internalBinaryWrite(message.squatMedia, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footBackViewData = 8; */
        if (message.footBackViewData)
            StringValue.internalBinaryWrite(message.footBackViewData, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footVerticalViewMedia = 9; */
        if (message.footVerticalViewMedia)
            StringValue.internalBinaryWrite(message.footVerticalViewMedia, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue archFigureMediaLeft = 10; */
        if (message.archFigureMediaLeft)
            StringValue.internalBinaryWrite(message.archFigureMediaLeft, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue archFigureMediaRight = 11; */
        if (message.archFigureMediaRight)
            StringValue.internalBinaryWrite(message.archFigureMediaRight, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footFigureMedia = 12; */
        if (message.footFigureMedia)
            StringValue.internalBinaryWrite(message.footFigureMedia, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footLengthRight = 13; */
        if (message.footLengthRight)
            StringValue.internalBinaryWrite(message.footLengthRight, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.OrderStatus orderStatus = 14; */
        if (message.orderStatus !== 0)
            writer.tag(14, WireType.Varint).int32(message.orderStatus);
        /* google.protobuf.Int64Value insoleCustomDataId = 15; */
        if (message.insoleCustomDataId)
            Int64Value.internalBinaryWrite(message.insoleCustomDataId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footWidthRight = 16; */
        if (message.footWidthRight)
            StringValue.internalBinaryWrite(message.footWidthRight, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footHeightRight = 17; */
        if (message.footHeightRight)
            StringValue.internalBinaryWrite(message.footHeightRight, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.ShippingStatus shippingStatus = 18; */
        if (message.shippingStatus !== 0)
            writer.tag(18, WireType.Varint).int32(message.shippingStatus);
        /* google.protobuf.Int64Value accountId = 19; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footLengthLeft = 20; */
        if (message.footLengthLeft)
            StringValue.internalBinaryWrite(message.footLengthLeft, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footWidthLeft = 21; */
        if (message.footWidthLeft)
            StringValue.internalBinaryWrite(message.footWidthLeft, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue footHeightLeft = 22; */
        if (message.footHeightLeft)
            StringValue.internalBinaryWrite(message.footHeightLeft, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* int64 createTimestamp = 23; */
        if (message.createTimestamp !== "0")
            writer.tag(23, WireType.Varint).int64(message.createTimestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.InsoleCustomData
 */
export const InsoleCustomData = new InsoleCustomData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPersonaRequest$Type extends MessageType<GetAllPersonaRequest> {
    constructor() {
        super("base.persona.GetAllPersonaRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAllPersonaRequest>): GetAllPersonaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllPersonaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllPersonaRequest): GetAllPersonaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllPersonaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAllPersonaRequest
 */
export const GetAllPersonaRequest = new GetAllPersonaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPersonaResponse$Type extends MessageType<GetAllPersonaResponse> {
    constructor() {
        super("base.persona.GetAllPersonaResponse", [
            { no: 1, name: "allPersona", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AllPersona }
        ]);
    }
    create(value?: PartialMessage<GetAllPersonaResponse>): GetAllPersonaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allPersona = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllPersonaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllPersonaResponse): GetAllPersonaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.AllPersona allPersona */ 1:
                    message.allPersona.push(AllPersona.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllPersonaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.AllPersona allPersona = 1; */
        for (let i = 0; i < message.allPersona.length; i++)
            AllPersona.internalBinaryWrite(message.allPersona[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetAllPersonaResponse
 */
export const GetAllPersonaResponse = new GetAllPersonaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllPersona$Type extends MessageType<AllPersona> {
    constructor() {
        super("base.persona.AllPersona", [
            { no: 2, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "bodyInfoResult", kind: "message", T: () => BodyInfo },
            { no: 6, name: "socialResult", kind: "message", T: () => SocialInfo },
            { no: 8, name: "contactInfoResult", kind: "message", T: () => ContactInfo },
            { no: 10, name: "workInfoResult", kind: "message", T: () => WorkInfo },
            { no: 12, name: "intrinsicInfoResult", kind: "message", T: () => IntrinsicInfo }
        ]);
    }
    create(value?: PartialMessage<AllPersona>): AllPersona {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<AllPersona>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllPersona): AllPersona {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                case /* base.persona.BodyInfo bodyInfoResult */ 4:
                    message.bodyInfoResult = BodyInfo.internalBinaryRead(reader, reader.uint32(), options, message.bodyInfoResult);
                    break;
                case /* base.persona.SocialInfo socialResult */ 6:
                    message.socialResult = SocialInfo.internalBinaryRead(reader, reader.uint32(), options, message.socialResult);
                    break;
                case /* base.persona.ContactInfo contactInfoResult */ 8:
                    message.contactInfoResult = ContactInfo.internalBinaryRead(reader, reader.uint32(), options, message.contactInfoResult);
                    break;
                case /* base.persona.WorkInfo workInfoResult */ 10:
                    message.workInfoResult = WorkInfo.internalBinaryRead(reader, reader.uint32(), options, message.workInfoResult);
                    break;
                case /* base.persona.IntrinsicInfo intrinsicInfoResult */ 12:
                    message.intrinsicInfoResult = IntrinsicInfo.internalBinaryRead(reader, reader.uint32(), options, message.intrinsicInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllPersona, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        /* base.persona.BodyInfo bodyInfoResult = 4; */
        if (message.bodyInfoResult)
            BodyInfo.internalBinaryWrite(message.bodyInfoResult, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.SocialInfo socialResult = 6; */
        if (message.socialResult)
            SocialInfo.internalBinaryWrite(message.socialResult, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.ContactInfo contactInfoResult = 8; */
        if (message.contactInfoResult)
            ContactInfo.internalBinaryWrite(message.contactInfoResult, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.WorkInfo workInfoResult = 10; */
        if (message.workInfoResult)
            WorkInfo.internalBinaryWrite(message.workInfoResult, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.IntrinsicInfo intrinsicInfoResult = 12; */
        if (message.intrinsicInfoResult)
            IntrinsicInfo.internalBinaryWrite(message.intrinsicInfoResult, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.AllPersona
 */
export const AllPersona = new AllPersona$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBodyByAccessTokenRequest$Type extends MessageType<CreateBodyByAccessTokenRequest> {
    constructor() {
        super("base.persona.CreateBodyByAccessTokenRequest", [
            { no: 1, name: "bodyInfo", kind: "message", T: () => CreateBodyByAccessToken }
        ]);
    }
    create(value?: PartialMessage<CreateBodyByAccessTokenRequest>): CreateBodyByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateBodyByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBodyByAccessTokenRequest): CreateBodyByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.CreateBodyByAccessToken bodyInfo */ 1:
                    message.bodyInfo = CreateBodyByAccessToken.internalBinaryRead(reader, reader.uint32(), options, message.bodyInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBodyByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.CreateBodyByAccessToken bodyInfo = 1; */
        if (message.bodyInfo)
            CreateBodyByAccessToken.internalBinaryWrite(message.bodyInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateBodyByAccessTokenRequest
 */
export const CreateBodyByAccessTokenRequest = new CreateBodyByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBodyByAccessToken$Type extends MessageType<CreateBodyByAccessToken> {
    constructor() {
        super("base.persona.CreateBodyByAccessToken", [
            { no: 2, name: "heightScalar", kind: "message", T: () => StringValue },
            { no: 3, name: "heightUnit", kind: "message", T: () => StringValue },
            { no: 4, name: "weightScalar", kind: "message", T: () => StringValue },
            { no: 5, name: "weightUnit", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateBodyByAccessToken>): CreateBodyByAccessToken {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateBodyByAccessToken>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBodyByAccessToken): CreateBodyByAccessToken {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue heightScalar */ 2:
                    message.heightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightScalar);
                    break;
                case /* google.protobuf.StringValue heightUnit */ 3:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.StringValue weightScalar */ 4:
                    message.weightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightScalar);
                    break;
                case /* google.protobuf.StringValue weightUnit */ 5:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBodyByAccessToken, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue heightScalar = 2; */
        if (message.heightScalar)
            StringValue.internalBinaryWrite(message.heightScalar, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightUnit = 3; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightScalar = 4; */
        if (message.weightScalar)
            StringValue.internalBinaryWrite(message.weightScalar, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightUnit = 5; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateBodyByAccessToken
 */
export const CreateBodyByAccessToken = new CreateBodyByAccessToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBodyByAccessTokenResponse$Type extends MessageType<CreateBodyByAccessTokenResponse> {
    constructor() {
        super("base.persona.CreateBodyByAccessTokenResponse", [
            { no: 1, name: "bodyId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateBodyByAccessTokenResponse>): CreateBodyByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bodyId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateBodyByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBodyByAccessTokenResponse): CreateBodyByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bodyId */ 1:
                    message.bodyId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBodyByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 bodyId = 1; */
        if (message.bodyId !== "0")
            writer.tag(1, WireType.Varint).int64(message.bodyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateBodyByAccessTokenResponse
 */
export const CreateBodyByAccessTokenResponse = new CreateBodyByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateIntrinsicByAccessTokenRequest$Type extends MessageType<CreateOrUpdateIntrinsicByAccessTokenRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateIntrinsicByAccessTokenRequest", [
            { no: 2, name: "birthdate", kind: "message", T: () => Int64Value },
            { no: 3, name: "gender", kind: "enum", T: () => ["base.persona.Gender", Gender] }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateIntrinsicByAccessTokenRequest>): CreateOrUpdateIntrinsicByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gender = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateIntrinsicByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateIntrinsicByAccessTokenRequest): CreateOrUpdateIntrinsicByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value birthdate */ 2:
                    message.birthdate = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.birthdate);
                    break;
                case /* base.persona.Gender gender */ 3:
                    message.gender = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateIntrinsicByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value birthdate = 2; */
        if (message.birthdate)
            Int64Value.internalBinaryWrite(message.birthdate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.Gender gender = 3; */
        if (message.gender !== 0)
            writer.tag(3, WireType.Varint).int32(message.gender);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateIntrinsicByAccessTokenRequest
 */
export const CreateOrUpdateIntrinsicByAccessTokenRequest = new CreateOrUpdateIntrinsicByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateIntrinsicByAccessTokenResponse$Type extends MessageType<CreateOrUpdateIntrinsicByAccessTokenResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateIntrinsicByAccessTokenResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateIntrinsicByAccessTokenResponse>): CreateOrUpdateIntrinsicByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateIntrinsicByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateIntrinsicByAccessTokenResponse): CreateOrUpdateIntrinsicByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateIntrinsicByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateIntrinsicByAccessTokenResponse
 */
export const CreateOrUpdateIntrinsicByAccessTokenResponse = new CreateOrUpdateIntrinsicByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateContactByAccessTokenRequest$Type extends MessageType<CreateOrUpdateContactByAccessTokenRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateContactByAccessTokenRequest", [
            { no: 2, name: "mobileNumber", kind: "message", T: () => StringValue },
            { no: 3, name: "address", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateContactByAccessTokenRequest>): CreateOrUpdateContactByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateContactByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateContactByAccessTokenRequest): CreateOrUpdateContactByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue mobileNumber */ 2:
                    message.mobileNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.mobileNumber);
                    break;
                case /* google.protobuf.Int64Value address */ 3:
                    message.address = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateContactByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue mobileNumber = 2; */
        if (message.mobileNumber)
            StringValue.internalBinaryWrite(message.mobileNumber, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value address = 3; */
        if (message.address)
            Int64Value.internalBinaryWrite(message.address, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateContactByAccessTokenRequest
 */
export const CreateOrUpdateContactByAccessTokenRequest = new CreateOrUpdateContactByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateContactByAccessTokenResponse$Type extends MessageType<CreateOrUpdateContactByAccessTokenResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateContactByAccessTokenResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateContactByAccessTokenResponse>): CreateOrUpdateContactByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateContactByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateContactByAccessTokenResponse): CreateOrUpdateContactByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateContactByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateContactByAccessTokenResponse
 */
export const CreateOrUpdateContactByAccessTokenResponse = new CreateOrUpdateContactByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateWorkByAccessTokenRequest$Type extends MessageType<CreateOrUpdateWorkByAccessTokenRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateWorkByAccessTokenRequest", [
            { no: 2, name: "profession", kind: "message", T: () => StringValue },
            { no: 3, name: "income", kind: "message", T: () => DoubleValue },
            { no: 4, name: "resume", kind: "message", T: () => StringValue },
            { no: 5, name: "signature", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateWorkByAccessTokenRequest>): CreateOrUpdateWorkByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateWorkByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateWorkByAccessTokenRequest): CreateOrUpdateWorkByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue profession */ 2:
                    message.profession = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.profession);
                    break;
                case /* google.protobuf.DoubleValue income */ 3:
                    message.income = DoubleValue.internalBinaryRead(reader, reader.uint32(), options, message.income);
                    break;
                case /* google.protobuf.StringValue resume */ 4:
                    message.resume = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.resume);
                    break;
                case /* google.protobuf.StringValue signature */ 5:
                    message.signature = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateWorkByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue profession = 2; */
        if (message.profession)
            StringValue.internalBinaryWrite(message.profession, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.DoubleValue income = 3; */
        if (message.income)
            DoubleValue.internalBinaryWrite(message.income, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue resume = 4; */
        if (message.resume)
            StringValue.internalBinaryWrite(message.resume, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue signature = 5; */
        if (message.signature)
            StringValue.internalBinaryWrite(message.signature, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateWorkByAccessTokenRequest
 */
export const CreateOrUpdateWorkByAccessTokenRequest = new CreateOrUpdateWorkByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateWorkByAccessTokenResponse$Type extends MessageType<CreateOrUpdateWorkByAccessTokenResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateWorkByAccessTokenResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateWorkByAccessTokenResponse>): CreateOrUpdateWorkByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateWorkByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateWorkByAccessTokenResponse): CreateOrUpdateWorkByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateWorkByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateWorkByAccessTokenResponse
 */
export const CreateOrUpdateWorkByAccessTokenResponse = new CreateOrUpdateWorkByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateSocialByAccessTokenRequest$Type extends MessageType<CreateOrUpdateSocialByAccessTokenRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateSocialByAccessTokenRequest", [
            { no: 2, name: "avatar", kind: "message", T: () => StringValue },
            { no: 3, name: "realName", kind: "message", T: () => StringValue },
            { no: 4, name: "displayName", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateSocialByAccessTokenRequest>): CreateOrUpdateSocialByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateSocialByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateSocialByAccessTokenRequest): CreateOrUpdateSocialByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue avatar */ 2:
                    message.avatar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.avatar);
                    break;
                case /* google.protobuf.StringValue realName */ 3:
                    message.realName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.realName);
                    break;
                case /* google.protobuf.StringValue displayName */ 4:
                    message.displayName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.displayName);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateSocialByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue avatar = 2; */
        if (message.avatar)
            StringValue.internalBinaryWrite(message.avatar, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue realName = 3; */
        if (message.realName)
            StringValue.internalBinaryWrite(message.realName, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue displayName = 4; */
        if (message.displayName)
            StringValue.internalBinaryWrite(message.displayName, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateSocialByAccessTokenRequest
 */
export const CreateOrUpdateSocialByAccessTokenRequest = new CreateOrUpdateSocialByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateSocialByAccessTokenResponse$Type extends MessageType<CreateOrUpdateSocialByAccessTokenResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateSocialByAccessTokenResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateSocialByAccessTokenResponse>): CreateOrUpdateSocialByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateSocialByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateSocialByAccessTokenResponse): CreateOrUpdateSocialByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateSocialByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateSocialByAccessTokenResponse
 */
export const CreateOrUpdateSocialByAccessTokenResponse = new CreateOrUpdateSocialByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIntrinsicRequest$Type extends MessageType<GetIntrinsicRequest> {
    constructor() {
        super("base.persona.GetIntrinsicRequest", []);
    }
    create(value?: PartialMessage<GetIntrinsicRequest>): GetIntrinsicRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIntrinsicRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIntrinsicRequest): GetIntrinsicRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIntrinsicRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetIntrinsicRequest
 */
export const GetIntrinsicRequest = new GetIntrinsicRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIntrinsicResponse$Type extends MessageType<GetIntrinsicResponse> {
    constructor() {
        super("base.persona.GetIntrinsicResponse", [
            { no: 1, name: "intrinsicInfoResult", kind: "message", T: () => IntrinsicInfo }
        ]);
    }
    create(value?: PartialMessage<GetIntrinsicResponse>): GetIntrinsicResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIntrinsicResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIntrinsicResponse): GetIntrinsicResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.IntrinsicInfo intrinsicInfoResult */ 1:
                    message.intrinsicInfoResult = IntrinsicInfo.internalBinaryRead(reader, reader.uint32(), options, message.intrinsicInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIntrinsicResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.IntrinsicInfo intrinsicInfoResult = 1; */
        if (message.intrinsicInfoResult)
            IntrinsicInfo.internalBinaryWrite(message.intrinsicInfoResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetIntrinsicResponse
 */
export const GetIntrinsicResponse = new GetIntrinsicResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorkRequest$Type extends MessageType<GetWorkRequest> {
    constructor() {
        super("base.persona.GetWorkRequest", []);
    }
    create(value?: PartialMessage<GetWorkRequest>): GetWorkRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetWorkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetWorkRequest): GetWorkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetWorkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetWorkRequest
 */
export const GetWorkRequest = new GetWorkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorkResponse$Type extends MessageType<GetWorkResponse> {
    constructor() {
        super("base.persona.GetWorkResponse", [
            { no: 1, name: "workInfoResult", kind: "message", T: () => WorkInfo }
        ]);
    }
    create(value?: PartialMessage<GetWorkResponse>): GetWorkResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetWorkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetWorkResponse): GetWorkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.WorkInfo workInfoResult */ 1:
                    message.workInfoResult = WorkInfo.internalBinaryRead(reader, reader.uint32(), options, message.workInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetWorkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.WorkInfo workInfoResult = 1; */
        if (message.workInfoResult)
            WorkInfo.internalBinaryWrite(message.workInfoResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetWorkResponse
 */
export const GetWorkResponse = new GetWorkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContactRequest$Type extends MessageType<GetContactRequest> {
    constructor() {
        super("base.persona.GetContactRequest", []);
    }
    create(value?: PartialMessage<GetContactRequest>): GetContactRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetContactRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetContactRequest): GetContactRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetContactRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetContactRequest
 */
export const GetContactRequest = new GetContactRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContactResponse$Type extends MessageType<GetContactResponse> {
    constructor() {
        super("base.persona.GetContactResponse", [
            { no: 1, name: "contactInfoResult", kind: "message", T: () => ContactInfo }
        ]);
    }
    create(value?: PartialMessage<GetContactResponse>): GetContactResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetContactResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetContactResponse): GetContactResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.ContactInfo contactInfoResult */ 1:
                    message.contactInfoResult = ContactInfo.internalBinaryRead(reader, reader.uint32(), options, message.contactInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetContactResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.ContactInfo contactInfoResult = 1; */
        if (message.contactInfoResult)
            ContactInfo.internalBinaryWrite(message.contactInfoResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetContactResponse
 */
export const GetContactResponse = new GetContactResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialRequest$Type extends MessageType<GetSocialRequest> {
    constructor() {
        super("base.persona.GetSocialRequest", []);
    }
    create(value?: PartialMessage<GetSocialRequest>): GetSocialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSocialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSocialRequest): GetSocialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSocialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetSocialRequest
 */
export const GetSocialRequest = new GetSocialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialResponse$Type extends MessageType<GetSocialResponse> {
    constructor() {
        super("base.persona.GetSocialResponse", [
            { no: 1, name: "socialResult", kind: "message", T: () => SocialInfo }
        ]);
    }
    create(value?: PartialMessage<GetSocialResponse>): GetSocialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSocialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSocialResponse): GetSocialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.SocialInfo socialResult */ 1:
                    message.socialResult = SocialInfo.internalBinaryRead(reader, reader.uint32(), options, message.socialResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSocialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.SocialInfo socialResult = 1; */
        if (message.socialResult)
            SocialInfo.internalBinaryWrite(message.socialResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetSocialResponse
 */
export const GetSocialResponse = new GetSocialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBodyRequest$Type extends MessageType<GetBodyRequest> {
    constructor() {
        super("base.persona.GetBodyRequest", []);
    }
    create(value?: PartialMessage<GetBodyRequest>): GetBodyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetBodyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBodyRequest): GetBodyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBodyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetBodyRequest
 */
export const GetBodyRequest = new GetBodyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBodyResponse$Type extends MessageType<GetBodyResponse> {
    constructor() {
        super("base.persona.GetBodyResponse", [
            { no: 1, name: "bodyInfoResult", kind: "message", T: () => BodyInfo }
        ]);
    }
    create(value?: PartialMessage<GetBodyResponse>): GetBodyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetBodyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBodyResponse): GetBodyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.BodyInfo bodyInfoResult */ 1:
                    message.bodyInfoResult = BodyInfo.internalBinaryRead(reader, reader.uint32(), options, message.bodyInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBodyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.BodyInfo bodyInfoResult = 1; */
        if (message.bodyInfoResult)
            BodyInfo.internalBinaryWrite(message.bodyInfoResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetBodyResponse
 */
export const GetBodyResponse = new GetBodyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SocialInfo$Type extends MessageType<SocialInfo> {
    constructor() {
        super("base.persona.SocialInfo", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "avatar", kind: "message", T: () => StringValue },
            { no: 3, name: "realName", kind: "message", T: () => StringValue },
            { no: 4, name: "displayName", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<SocialInfo>): SocialInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<SocialInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SocialInfo): SocialInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue avatar */ 2:
                    message.avatar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.avatar);
                    break;
                case /* google.protobuf.StringValue realName */ 3:
                    message.realName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.realName);
                    break;
                case /* google.protobuf.StringValue displayName */ 4:
                    message.displayName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.displayName);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SocialInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue avatar = 2; */
        if (message.avatar)
            StringValue.internalBinaryWrite(message.avatar, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue realName = 3; */
        if (message.realName)
            StringValue.internalBinaryWrite(message.realName, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue displayName = 4; */
        if (message.displayName)
            StringValue.internalBinaryWrite(message.displayName, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.SocialInfo
 */
export const SocialInfo = new SocialInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSocialRequest$Type extends MessageType<CreateSocialRequest> {
    constructor() {
        super("base.persona.CreateSocialRequest", [
            { no: 1, name: "socialInfo", kind: "message", T: () => SocialInfo }
        ]);
    }
    create(value?: PartialMessage<CreateSocialRequest>): CreateSocialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateSocialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSocialRequest): CreateSocialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.SocialInfo socialInfo */ 1:
                    message.socialInfo = SocialInfo.internalBinaryRead(reader, reader.uint32(), options, message.socialInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSocialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.SocialInfo socialInfo = 1; */
        if (message.socialInfo)
            SocialInfo.internalBinaryWrite(message.socialInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateSocialRequest
 */
export const CreateSocialRequest = new CreateSocialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSocialResponse$Type extends MessageType<CreateSocialResponse> {
    constructor() {
        super("base.persona.CreateSocialResponse", [
            { no: 1, name: "socialId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateSocialResponse>): CreateSocialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.socialId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateSocialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateSocialResponse): CreateSocialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 socialId */ 1:
                    message.socialId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateSocialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 socialId = 1; */
        if (message.socialId !== "0")
            writer.tag(1, WireType.Varint).int64(message.socialId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateSocialResponse
 */
export const CreateSocialResponse = new CreateSocialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSocialRequest$Type extends MessageType<UpdateSocialRequest> {
    constructor() {
        super("base.persona.UpdateSocialRequest", [
            { no: 1, name: "socialInfo", kind: "message", T: () => SocialInfo }
        ]);
    }
    create(value?: PartialMessage<UpdateSocialRequest>): UpdateSocialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSocialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSocialRequest): UpdateSocialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.SocialInfo socialInfo */ 1:
                    message.socialInfo = SocialInfo.internalBinaryRead(reader, reader.uint32(), options, message.socialInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSocialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.SocialInfo socialInfo = 1; */
        if (message.socialInfo)
            SocialInfo.internalBinaryWrite(message.socialInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateSocialRequest
 */
export const UpdateSocialRequest = new UpdateSocialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSocialResponse$Type extends MessageType<UpdateSocialResponse> {
    constructor() {
        super("base.persona.UpdateSocialResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateSocialResponse>): UpdateSocialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateSocialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSocialResponse): UpdateSocialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSocialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateSocialResponse
 */
export const UpdateSocialResponse = new UpdateSocialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSocialRequest$Type extends MessageType<DeleteSocialRequest> {
    constructor() {
        super("base.persona.DeleteSocialRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteSocialRequest>): DeleteSocialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<DeleteSocialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSocialRequest): DeleteSocialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSocialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.DeleteSocialRequest
 */
export const DeleteSocialRequest = new DeleteSocialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSocialResponse$Type extends MessageType<DeleteSocialResponse> {
    constructor() {
        super("base.persona.DeleteSocialResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteSocialResponse>): DeleteSocialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteSocialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteSocialResponse): DeleteSocialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteSocialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.DeleteSocialResponse
 */
export const DeleteSocialResponse = new DeleteSocialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialByAccountIdsRequest$Type extends MessageType<GetSocialByAccountIdsRequest> {
    constructor() {
        super("base.persona.GetSocialByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetSocialByAccountIdsRequest>): GetSocialByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetSocialByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSocialByAccountIdsRequest): GetSocialByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSocialByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetSocialByAccountIdsRequest
 */
export const GetSocialByAccountIdsRequest = new GetSocialByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialByAccountIdsResponse$Type extends MessageType<GetSocialByAccountIdsResponse> {
    constructor() {
        super("base.persona.GetSocialByAccountIdsResponse", [
            { no: 1, name: "socialResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SocialInfo }
        ]);
    }
    create(value?: PartialMessage<GetSocialByAccountIdsResponse>): GetSocialByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.socialResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetSocialByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSocialByAccountIdsResponse): GetSocialByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.SocialInfo socialResults */ 1:
                    message.socialResults.push(SocialInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSocialByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.SocialInfo socialResults = 1; */
        for (let i = 0; i < message.socialResults.length; i++)
            SocialInfo.internalBinaryWrite(message.socialResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetSocialByAccountIdsResponse
 */
export const GetSocialByAccountIdsResponse = new GetSocialByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkInfo$Type extends MessageType<WorkInfo> {
    constructor() {
        super("base.persona.WorkInfo", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "profession", kind: "message", T: () => StringValue },
            { no: 3, name: "income", kind: "message", T: () => DoubleValue },
            { no: 4, name: "resume", kind: "message", T: () => StringValue },
            { no: 5, name: "signature", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<WorkInfo>): WorkInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<WorkInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkInfo): WorkInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue profession */ 2:
                    message.profession = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.profession);
                    break;
                case /* google.protobuf.DoubleValue income */ 3:
                    message.income = DoubleValue.internalBinaryRead(reader, reader.uint32(), options, message.income);
                    break;
                case /* google.protobuf.StringValue resume */ 4:
                    message.resume = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.resume);
                    break;
                case /* google.protobuf.StringValue signature */ 5:
                    message.signature = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue profession = 2; */
        if (message.profession)
            StringValue.internalBinaryWrite(message.profession, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.DoubleValue income = 3; */
        if (message.income)
            DoubleValue.internalBinaryWrite(message.income, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue resume = 4; */
        if (message.resume)
            StringValue.internalBinaryWrite(message.resume, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue signature = 5; */
        if (message.signature)
            StringValue.internalBinaryWrite(message.signature, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.WorkInfo
 */
export const WorkInfo = new WorkInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWorkRequest$Type extends MessageType<CreateWorkRequest> {
    constructor() {
        super("base.persona.CreateWorkRequest", [
            { no: 1, name: "workInfo", kind: "message", T: () => WorkInfo }
        ]);
    }
    create(value?: PartialMessage<CreateWorkRequest>): CreateWorkRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateWorkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateWorkRequest): CreateWorkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.WorkInfo workInfo */ 1:
                    message.workInfo = WorkInfo.internalBinaryRead(reader, reader.uint32(), options, message.workInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateWorkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.WorkInfo workInfo = 1; */
        if (message.workInfo)
            WorkInfo.internalBinaryWrite(message.workInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateWorkRequest
 */
export const CreateWorkRequest = new CreateWorkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWorkResponse$Type extends MessageType<CreateWorkResponse> {
    constructor() {
        super("base.persona.CreateWorkResponse", [
            { no: 1, name: "workId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateWorkResponse>): CreateWorkResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateWorkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateWorkResponse): CreateWorkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 workId */ 1:
                    message.workId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateWorkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 workId = 1; */
        if (message.workId !== "0")
            writer.tag(1, WireType.Varint).int64(message.workId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateWorkResponse
 */
export const CreateWorkResponse = new CreateWorkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWorkRequest$Type extends MessageType<UpdateWorkRequest> {
    constructor() {
        super("base.persona.UpdateWorkRequest", [
            { no: 1, name: "workInfo", kind: "message", T: () => WorkInfo }
        ]);
    }
    create(value?: PartialMessage<UpdateWorkRequest>): UpdateWorkRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateWorkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateWorkRequest): UpdateWorkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.WorkInfo workInfo */ 1:
                    message.workInfo = WorkInfo.internalBinaryRead(reader, reader.uint32(), options, message.workInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateWorkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.WorkInfo workInfo = 1; */
        if (message.workInfo)
            WorkInfo.internalBinaryWrite(message.workInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateWorkRequest
 */
export const UpdateWorkRequest = new UpdateWorkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWorkResponse$Type extends MessageType<UpdateWorkResponse> {
    constructor() {
        super("base.persona.UpdateWorkResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateWorkResponse>): UpdateWorkResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateWorkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateWorkResponse): UpdateWorkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateWorkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateWorkResponse
 */
export const UpdateWorkResponse = new UpdateWorkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorkByAccountIdsRequest$Type extends MessageType<GetWorkByAccountIdsRequest> {
    constructor() {
        super("base.persona.GetWorkByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetWorkByAccountIdsRequest>): GetWorkByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetWorkByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetWorkByAccountIdsRequest): GetWorkByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetWorkByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetWorkByAccountIdsRequest
 */
export const GetWorkByAccountIdsRequest = new GetWorkByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorkByAccountIdsResponse$Type extends MessageType<GetWorkByAccountIdsResponse> {
    constructor() {
        super("base.persona.GetWorkByAccountIdsResponse", [
            { no: 1, name: "workInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkInfo }
        ]);
    }
    create(value?: PartialMessage<GetWorkByAccountIdsResponse>): GetWorkByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetWorkByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetWorkByAccountIdsResponse): GetWorkByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.WorkInfo workInfoResults */ 1:
                    message.workInfoResults.push(WorkInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetWorkByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.WorkInfo workInfoResults = 1; */
        for (let i = 0; i < message.workInfoResults.length; i++)
            WorkInfo.internalBinaryWrite(message.workInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetWorkByAccountIdsResponse
 */
export const GetWorkByAccountIdsResponse = new GetWorkByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContactInfo$Type extends MessageType<ContactInfo> {
    constructor() {
        super("base.persona.ContactInfo", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "mobileNumber", kind: "message", T: () => StringValue },
            { no: 3, name: "address", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ContactInfo>): ContactInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<ContactInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ContactInfo): ContactInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue mobileNumber */ 2:
                    message.mobileNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.mobileNumber);
                    break;
                case /* google.protobuf.Int64Value address */ 3:
                    message.address = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ContactInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue mobileNumber = 2; */
        if (message.mobileNumber)
            StringValue.internalBinaryWrite(message.mobileNumber, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value address = 3; */
        if (message.address)
            Int64Value.internalBinaryWrite(message.address, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.ContactInfo
 */
export const ContactInfo = new ContactInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateContactRequest$Type extends MessageType<CreateContactRequest> {
    constructor() {
        super("base.persona.CreateContactRequest", [
            { no: 1, name: "contactInfo", kind: "message", T: () => ContactInfo }
        ]);
    }
    create(value?: PartialMessage<CreateContactRequest>): CreateContactRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateContactRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateContactRequest): CreateContactRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.ContactInfo contactInfo */ 1:
                    message.contactInfo = ContactInfo.internalBinaryRead(reader, reader.uint32(), options, message.contactInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateContactRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.ContactInfo contactInfo = 1; */
        if (message.contactInfo)
            ContactInfo.internalBinaryWrite(message.contactInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateContactRequest
 */
export const CreateContactRequest = new CreateContactRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateContactResponse$Type extends MessageType<CreateContactResponse> {
    constructor() {
        super("base.persona.CreateContactResponse", [
            { no: 1, name: "contactId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateContactResponse>): CreateContactResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.contactId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateContactResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateContactResponse): CreateContactResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 contactId */ 1:
                    message.contactId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateContactResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 contactId = 1; */
        if (message.contactId !== "0")
            writer.tag(1, WireType.Varint).int64(message.contactId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateContactResponse
 */
export const CreateContactResponse = new CreateContactResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateContactRequest$Type extends MessageType<UpdateContactRequest> {
    constructor() {
        super("base.persona.UpdateContactRequest", [
            { no: 1, name: "contactInfo", kind: "message", T: () => ContactInfo }
        ]);
    }
    create(value?: PartialMessage<UpdateContactRequest>): UpdateContactRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateContactRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateContactRequest): UpdateContactRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.ContactInfo contactInfo */ 1:
                    message.contactInfo = ContactInfo.internalBinaryRead(reader, reader.uint32(), options, message.contactInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateContactRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.ContactInfo contactInfo = 1; */
        if (message.contactInfo)
            ContactInfo.internalBinaryWrite(message.contactInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateContactRequest
 */
export const UpdateContactRequest = new UpdateContactRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateContactResponse$Type extends MessageType<UpdateContactResponse> {
    constructor() {
        super("base.persona.UpdateContactResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateContactResponse>): UpdateContactResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateContactResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateContactResponse): UpdateContactResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateContactResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateContactResponse
 */
export const UpdateContactResponse = new UpdateContactResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContactByAccountIdsRequest$Type extends MessageType<GetContactByAccountIdsRequest> {
    constructor() {
        super("base.persona.GetContactByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetContactByAccountIdsRequest>): GetContactByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetContactByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetContactByAccountIdsRequest): GetContactByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetContactByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetContactByAccountIdsRequest
 */
export const GetContactByAccountIdsRequest = new GetContactByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContactByAccountIdsResponse$Type extends MessageType<GetContactByAccountIdsResponse> {
    constructor() {
        super("base.persona.GetContactByAccountIdsResponse", [
            { no: 1, name: "contactInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ContactInfo }
        ]);
    }
    create(value?: PartialMessage<GetContactByAccountIdsResponse>): GetContactByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.contactInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetContactByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetContactByAccountIdsResponse): GetContactByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.ContactInfo contactInfoResults */ 1:
                    message.contactInfoResults.push(ContactInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetContactByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.ContactInfo contactInfoResults = 1; */
        for (let i = 0; i < message.contactInfoResults.length; i++)
            ContactInfo.internalBinaryWrite(message.contactInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetContactByAccountIdsResponse
 */
export const GetContactByAccountIdsResponse = new GetContactByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BodyInfo$Type extends MessageType<BodyInfo> {
    constructor() {
        super("base.persona.BodyInfo", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "heightScalar", kind: "message", T: () => StringValue },
            { no: 3, name: "heightUnit", kind: "message", T: () => StringValue },
            { no: 4, name: "weightScalar", kind: "message", T: () => StringValue },
            { no: 5, name: "weightUnit", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<BodyInfo>): BodyInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<BodyInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BodyInfo): BodyInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue heightScalar */ 2:
                    message.heightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightScalar);
                    break;
                case /* google.protobuf.StringValue heightUnit */ 3:
                    message.heightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.heightUnit);
                    break;
                case /* google.protobuf.StringValue weightScalar */ 4:
                    message.weightScalar = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightScalar);
                    break;
                case /* google.protobuf.StringValue weightUnit */ 5:
                    message.weightUnit = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.weightUnit);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BodyInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue heightScalar = 2; */
        if (message.heightScalar)
            StringValue.internalBinaryWrite(message.heightScalar, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue heightUnit = 3; */
        if (message.heightUnit)
            StringValue.internalBinaryWrite(message.heightUnit, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightScalar = 4; */
        if (message.weightScalar)
            StringValue.internalBinaryWrite(message.weightScalar, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue weightUnit = 5; */
        if (message.weightUnit)
            StringValue.internalBinaryWrite(message.weightUnit, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.BodyInfo
 */
export const BodyInfo = new BodyInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBodyRequest$Type extends MessageType<CreateBodyRequest> {
    constructor() {
        super("base.persona.CreateBodyRequest", [
            { no: 1, name: "bodyInfo", kind: "message", T: () => BodyInfo }
        ]);
    }
    create(value?: PartialMessage<CreateBodyRequest>): CreateBodyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateBodyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBodyRequest): CreateBodyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.BodyInfo bodyInfo */ 1:
                    message.bodyInfo = BodyInfo.internalBinaryRead(reader, reader.uint32(), options, message.bodyInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBodyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.BodyInfo bodyInfo = 1; */
        if (message.bodyInfo)
            BodyInfo.internalBinaryWrite(message.bodyInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateBodyRequest
 */
export const CreateBodyRequest = new CreateBodyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBodyResponse$Type extends MessageType<CreateBodyResponse> {
    constructor() {
        super("base.persona.CreateBodyResponse", [
            { no: 1, name: "bodyId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateBodyResponse>): CreateBodyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bodyId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateBodyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBodyResponse): CreateBodyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 bodyId */ 1:
                    message.bodyId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBodyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 bodyId = 1; */
        if (message.bodyId !== "0")
            writer.tag(1, WireType.Varint).int64(message.bodyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateBodyResponse
 */
export const CreateBodyResponse = new CreateBodyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBodyByAccountIdsRequest$Type extends MessageType<GetBodyByAccountIdsRequest> {
    constructor() {
        super("base.persona.GetBodyByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetBodyByAccountIdsRequest>): GetBodyByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetBodyByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBodyByAccountIdsRequest): GetBodyByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBodyByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetBodyByAccountIdsRequest
 */
export const GetBodyByAccountIdsRequest = new GetBodyByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBodyByAccountIdsResponse$Type extends MessageType<GetBodyByAccountIdsResponse> {
    constructor() {
        super("base.persona.GetBodyByAccountIdsResponse", [
            { no: 1, name: "bodyInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BodyInfo }
        ]);
    }
    create(value?: PartialMessage<GetBodyByAccountIdsResponse>): GetBodyByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bodyInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetBodyByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBodyByAccountIdsResponse): GetBodyByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.BodyInfo bodyInfoResults */ 1:
                    message.bodyInfoResults.push(BodyInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBodyByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.BodyInfo bodyInfoResults = 1; */
        for (let i = 0; i < message.bodyInfoResults.length; i++)
            BodyInfo.internalBinaryWrite(message.bodyInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetBodyByAccountIdsResponse
 */
export const GetBodyByAccountIdsResponse = new GetBodyByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrinsicInfo$Type extends MessageType<IntrinsicInfo> {
    constructor() {
        super("base.persona.IntrinsicInfo", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "birthdate", kind: "message", T: () => Int64Value },
            { no: 3, name: "gender", kind: "enum", T: () => ["base.persona.Gender", Gender] }
        ]);
    }
    create(value?: PartialMessage<IntrinsicInfo>): IntrinsicInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.gender = 0;
        if (value !== undefined)
            reflectionMergePartial<IntrinsicInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrinsicInfo): IntrinsicInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.Int64Value birthdate */ 2:
                    message.birthdate = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.birthdate);
                    break;
                case /* base.persona.Gender gender */ 3:
                    message.gender = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrinsicInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.Int64Value birthdate = 2; */
        if (message.birthdate)
            Int64Value.internalBinaryWrite(message.birthdate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* base.persona.Gender gender = 3; */
        if (message.gender !== 0)
            writer.tag(3, WireType.Varint).int32(message.gender);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.IntrinsicInfo
 */
export const IntrinsicInfo = new IntrinsicInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateIntrinsicRequest$Type extends MessageType<CreateIntrinsicRequest> {
    constructor() {
        super("base.persona.CreateIntrinsicRequest", [
            { no: 1, name: "intrinsicInfo", kind: "message", T: () => IntrinsicInfo }
        ]);
    }
    create(value?: PartialMessage<CreateIntrinsicRequest>): CreateIntrinsicRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateIntrinsicRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateIntrinsicRequest): CreateIntrinsicRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.IntrinsicInfo intrinsicInfo */ 1:
                    message.intrinsicInfo = IntrinsicInfo.internalBinaryRead(reader, reader.uint32(), options, message.intrinsicInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateIntrinsicRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.IntrinsicInfo intrinsicInfo = 1; */
        if (message.intrinsicInfo)
            IntrinsicInfo.internalBinaryWrite(message.intrinsicInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateIntrinsicRequest
 */
export const CreateIntrinsicRequest = new CreateIntrinsicRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateIntrinsicResponse$Type extends MessageType<CreateIntrinsicResponse> {
    constructor() {
        super("base.persona.CreateIntrinsicResponse", [
            { no: 1, name: "IntrinsicId", kind: "scalar", jsonName: "IntrinsicId", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateIntrinsicResponse>): CreateIntrinsicResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.intrinsicId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateIntrinsicResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateIntrinsicResponse): CreateIntrinsicResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 IntrinsicId */ 1:
                    message.intrinsicId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateIntrinsicResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 IntrinsicId = 1; */
        if (message.intrinsicId !== "0")
            writer.tag(1, WireType.Varint).int64(message.intrinsicId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateIntrinsicResponse
 */
export const CreateIntrinsicResponse = new CreateIntrinsicResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIntrinsicRequest$Type extends MessageType<UpdateIntrinsicRequest> {
    constructor() {
        super("base.persona.UpdateIntrinsicRequest", [
            { no: 1, name: "intrinsicInfo", kind: "message", T: () => IntrinsicInfo }
        ]);
    }
    create(value?: PartialMessage<UpdateIntrinsicRequest>): UpdateIntrinsicRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateIntrinsicRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateIntrinsicRequest): UpdateIntrinsicRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.IntrinsicInfo intrinsicInfo */ 1:
                    message.intrinsicInfo = IntrinsicInfo.internalBinaryRead(reader, reader.uint32(), options, message.intrinsicInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateIntrinsicRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.IntrinsicInfo intrinsicInfo = 1; */
        if (message.intrinsicInfo)
            IntrinsicInfo.internalBinaryWrite(message.intrinsicInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateIntrinsicRequest
 */
export const UpdateIntrinsicRequest = new UpdateIntrinsicRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIntrinsicResponse$Type extends MessageType<UpdateIntrinsicResponse> {
    constructor() {
        super("base.persona.UpdateIntrinsicResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateIntrinsicResponse>): UpdateIntrinsicResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateIntrinsicResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateIntrinsicResponse): UpdateIntrinsicResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateIntrinsicResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.UpdateIntrinsicResponse
 */
export const UpdateIntrinsicResponse = new UpdateIntrinsicResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIntrinsicByAccountIdsRequest$Type extends MessageType<GetIntrinsicByAccountIdsRequest> {
    constructor() {
        super("base.persona.GetIntrinsicByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetIntrinsicByAccountIdsRequest>): GetIntrinsicByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetIntrinsicByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIntrinsicByAccountIdsRequest): GetIntrinsicByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIntrinsicByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetIntrinsicByAccountIdsRequest
 */
export const GetIntrinsicByAccountIdsRequest = new GetIntrinsicByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIntrinsicByAccountIdsResponse$Type extends MessageType<GetIntrinsicByAccountIdsResponse> {
    constructor() {
        super("base.persona.GetIntrinsicByAccountIdsResponse", [
            { no: 1, name: "intrinsicInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IntrinsicInfo }
        ]);
    }
    create(value?: PartialMessage<GetIntrinsicByAccountIdsResponse>): GetIntrinsicByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.intrinsicInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetIntrinsicByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIntrinsicByAccountIdsResponse): GetIntrinsicByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.IntrinsicInfo intrinsicInfoResults */ 1:
                    message.intrinsicInfoResults.push(IntrinsicInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIntrinsicByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.IntrinsicInfo intrinsicInfoResults = 1; */
        for (let i = 0; i < message.intrinsicInfoResults.length; i++)
            IntrinsicInfo.internalBinaryWrite(message.intrinsicInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetIntrinsicByAccountIdsResponse
 */
export const GetIntrinsicByAccountIdsResponse = new GetIntrinsicByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateIntrinsicRequest$Type extends MessageType<CreateOrUpdateIntrinsicRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateIntrinsicRequest", [
            { no: 1, name: "intrinsicInfo", kind: "message", T: () => IntrinsicInfo }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateIntrinsicRequest>): CreateOrUpdateIntrinsicRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateIntrinsicRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateIntrinsicRequest): CreateOrUpdateIntrinsicRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.IntrinsicInfo intrinsicInfo */ 1:
                    message.intrinsicInfo = IntrinsicInfo.internalBinaryRead(reader, reader.uint32(), options, message.intrinsicInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateIntrinsicRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.IntrinsicInfo intrinsicInfo = 1; */
        if (message.intrinsicInfo)
            IntrinsicInfo.internalBinaryWrite(message.intrinsicInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateIntrinsicRequest
 */
export const CreateOrUpdateIntrinsicRequest = new CreateOrUpdateIntrinsicRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateIntrinsicResponse$Type extends MessageType<CreateOrUpdateIntrinsicResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateIntrinsicResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateIntrinsicResponse>): CreateOrUpdateIntrinsicResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateIntrinsicResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateIntrinsicResponse): CreateOrUpdateIntrinsicResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateIntrinsicResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateIntrinsicResponse
 */
export const CreateOrUpdateIntrinsicResponse = new CreateOrUpdateIntrinsicResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateContactRequest$Type extends MessageType<CreateOrUpdateContactRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateContactRequest", [
            { no: 1, name: "contactInfo", kind: "message", T: () => ContactInfo }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateContactRequest>): CreateOrUpdateContactRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateContactRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateContactRequest): CreateOrUpdateContactRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.ContactInfo contactInfo */ 1:
                    message.contactInfo = ContactInfo.internalBinaryRead(reader, reader.uint32(), options, message.contactInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateContactRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.ContactInfo contactInfo = 1; */
        if (message.contactInfo)
            ContactInfo.internalBinaryWrite(message.contactInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateContactRequest
 */
export const CreateOrUpdateContactRequest = new CreateOrUpdateContactRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateContactResponse$Type extends MessageType<CreateOrUpdateContactResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateContactResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateContactResponse>): CreateOrUpdateContactResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateContactResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateContactResponse): CreateOrUpdateContactResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateContactResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateContactResponse
 */
export const CreateOrUpdateContactResponse = new CreateOrUpdateContactResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateWorkRequest$Type extends MessageType<CreateOrUpdateWorkRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateWorkRequest", [
            { no: 1, name: "workInfo", kind: "message", T: () => WorkInfo }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateWorkRequest>): CreateOrUpdateWorkRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateWorkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateWorkRequest): CreateOrUpdateWorkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.WorkInfo workInfo */ 1:
                    message.workInfo = WorkInfo.internalBinaryRead(reader, reader.uint32(), options, message.workInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateWorkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.WorkInfo workInfo = 1; */
        if (message.workInfo)
            WorkInfo.internalBinaryWrite(message.workInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateWorkRequest
 */
export const CreateOrUpdateWorkRequest = new CreateOrUpdateWorkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateWorkResponse$Type extends MessageType<CreateOrUpdateWorkResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateWorkResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateWorkResponse>): CreateOrUpdateWorkResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateWorkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateWorkResponse): CreateOrUpdateWorkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateWorkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateWorkResponse
 */
export const CreateOrUpdateWorkResponse = new CreateOrUpdateWorkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateSocialRequest$Type extends MessageType<CreateOrUpdateSocialRequest> {
    constructor() {
        super("base.persona.CreateOrUpdateSocialRequest", [
            { no: 1, name: "socialInfo", kind: "message", T: () => SocialInfo }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateSocialRequest>): CreateOrUpdateSocialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateSocialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateSocialRequest): CreateOrUpdateSocialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.persona.SocialInfo socialInfo */ 1:
                    message.socialInfo = SocialInfo.internalBinaryRead(reader, reader.uint32(), options, message.socialInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateSocialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.persona.SocialInfo socialInfo = 1; */
        if (message.socialInfo)
            SocialInfo.internalBinaryWrite(message.socialInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateSocialRequest
 */
export const CreateOrUpdateSocialRequest = new CreateOrUpdateSocialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrUpdateSocialResponse$Type extends MessageType<CreateOrUpdateSocialResponse> {
    constructor() {
        super("base.persona.CreateOrUpdateSocialResponse", [
            { no: 1, name: "isFinished", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrUpdateSocialResponse>): CreateOrUpdateSocialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinished = false;
        if (value !== undefined)
            reflectionMergePartial<CreateOrUpdateSocialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrUpdateSocialResponse): CreateOrUpdateSocialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isFinished */ 1:
                    message.isFinished = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrUpdateSocialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isFinished = 1; */
        if (message.isFinished !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinished);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.CreateOrUpdateSocialResponse
 */
export const CreateOrUpdateSocialResponse = new CreateOrUpdateSocialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBodyListByAccountIdsRequest$Type extends MessageType<GetBodyListByAccountIdsRequest> {
    constructor() {
        super("base.persona.GetBodyListByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetBodyListByAccountIdsRequest>): GetBodyListByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetBodyListByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBodyListByAccountIdsRequest): GetBodyListByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBodyListByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetBodyListByAccountIdsRequest
 */
export const GetBodyListByAccountIdsRequest = new GetBodyListByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBodyListByAccountIdsResponse$Type extends MessageType<GetBodyListByAccountIdsResponse> {
    constructor() {
        super("base.persona.GetBodyListByAccountIdsResponse", [
            { no: 1, name: "bodyInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BodyInfo }
        ]);
    }
    create(value?: PartialMessage<GetBodyListByAccountIdsResponse>): GetBodyListByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bodyInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetBodyListByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBodyListByAccountIdsResponse): GetBodyListByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.persona.BodyInfo bodyInfoResults */ 1:
                    message.bodyInfoResults.push(BodyInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBodyListByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.persona.BodyInfo bodyInfoResults = 1; */
        for (let i = 0; i < message.bodyInfoResults.length; i++)
            BodyInfo.internalBinaryWrite(message.bodyInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetBodyListByAccountIdsResponse
 */
export const GetBodyListByAccountIdsResponse = new GetBodyListByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlRequest$Type extends MessageType<GetPresignedPutObjectUrlRequest> {
    constructor() {
        super("base.persona.GetPresignedPutObjectUrlRequest", [
            { no: 1, name: "object_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlRequest>): GetPresignedPutObjectUrlRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.objectType = "";
        message.key = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlRequest): GetPresignedPutObjectUrlRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string object_type */ 1:
                    message.objectType = reader.string();
                    break;
                case /* string key */ 2:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string object_type = 1; */
        if (message.objectType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.objectType);
        /* string key = 2; */
        if (message.key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetPresignedPutObjectUrlRequest
 */
export const GetPresignedPutObjectUrlRequest = new GetPresignedPutObjectUrlRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlResponse$Type extends MessageType<GetPresignedPutObjectUrlResponse> {
    constructor() {
        super("base.persona.GetPresignedPutObjectUrlResponse", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlResponse>): GetPresignedPutObjectUrlResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlResponse): GetPresignedPutObjectUrlResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.persona.GetPresignedPutObjectUrlResponse
 */
export const GetPresignedPutObjectUrlResponse = new GetPresignedPutObjectUrlResponse$Type();
/**
 * @generated ServiceType for protobuf service base.persona.PersonaService
 */
export const PersonaService = new ServiceType("base.persona.PersonaService", [
    { name: "CreateSocial", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateSocial", body: "*" } }, I: CreateSocialRequest, O: CreateSocialResponse },
    { name: "UpdateSocial", options: { "google.api.http": { post: "/base.persona.PersonaService/UpdateSocial", body: "*" } }, I: UpdateSocialRequest, O: UpdateSocialResponse },
    { name: "GetSocialByAccountIds", options: { "google.api.http": { post: "/base.persona.PersonaService/GetSocialByAccountIds", body: "*" } }, I: GetSocialByAccountIdsRequest, O: GetSocialByAccountIdsResponse },
    { name: "CreateWork", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateWork", body: "*" } }, I: CreateWorkRequest, O: CreateWorkResponse },
    { name: "UpdateWork", options: { "google.api.http": { post: "/base.persona.PersonaService/UpdateWork", body: "*" } }, I: UpdateWorkRequest, O: UpdateWorkResponse },
    { name: "GetWorkByAccountIds", options: { "google.api.http": { post: "/base.persona.PersonaService/GetWorkByAccountIds", body: "*" } }, I: GetWorkByAccountIdsRequest, O: GetWorkByAccountIdsResponse },
    { name: "CreateContact", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateContact", body: "*" } }, I: CreateContactRequest, O: CreateContactResponse },
    { name: "UpdateContact", options: { "google.api.http": { post: "/base.persona.PersonaService/UpdateContact", body: "*" } }, I: UpdateContactRequest, O: UpdateContactResponse },
    { name: "GetContactByAccountIds", options: { "google.api.http": { post: "/base.persona.PersonaService/GetContactByAccountIds", body: "*" } }, I: GetContactByAccountIdsRequest, O: GetContactByAccountIdsResponse },
    { name: "CreateBody", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateBody", body: "*" } }, I: CreateBodyRequest, O: CreateBodyResponse },
    { name: "GetBodyListByAccountIds", options: { "google.api.http": { post: "/base.persona.PersonaService/GetBodyListByAccountIds", body: "*" } }, I: GetBodyListByAccountIdsRequest, O: GetBodyListByAccountIdsResponse },
    { name: "GetBodyByAccountIds", options: { "google.api.http": { post: "/base.persona.PersonaService/GetBodyByAccountIds", body: "*" } }, I: GetBodyByAccountIdsRequest, O: GetBodyByAccountIdsResponse },
    { name: "CreateIntrinsic", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateIntrinsic", body: "*" } }, I: CreateIntrinsicRequest, O: CreateIntrinsicResponse },
    { name: "UpdateIntrinsic", options: { "google.api.http": { post: "/base.persona.PersonaService/UpdateIntrinsic", body: "*" } }, I: UpdateIntrinsicRequest, O: UpdateIntrinsicResponse },
    { name: "GetIntrinsicByAccountIds", options: { "google.api.http": { post: "/base.persona.PersonaService/GetIntrinsicByAccountIds", body: "*" } }, I: GetIntrinsicByAccountIdsRequest, O: GetIntrinsicByAccountIdsResponse },
    { name: "CreateOrUpdateIntrinsic", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateIntrinsic", body: "*" } }, I: CreateOrUpdateIntrinsicRequest, O: CreateOrUpdateIntrinsicResponse },
    { name: "CreateOrUpdateContact", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateContact", body: "*" } }, I: CreateOrUpdateContactRequest, O: CreateOrUpdateContactResponse },
    { name: "CreateOrUpdateWork", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateWork", body: "*" } }, I: CreateOrUpdateWorkRequest, O: CreateOrUpdateWorkResponse },
    { name: "CreateOrUpdateSocial", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateSocial", body: "*" } }, I: CreateOrUpdateSocialRequest, O: CreateOrUpdateSocialResponse },
    { name: "GetBody", options: { "google.api.http": { post: "/base.persona.PersonaService/GetBody", body: "*" } }, I: GetBodyRequest, O: GetBodyResponse },
    { name: "GetSocial", options: { "google.api.http": { post: "/base.persona.PersonaService/GetSocial", body: "*" } }, I: GetSocialRequest, O: GetSocialResponse },
    { name: "GetContact", options: { "google.api.http": { post: "/base.persona.PersonaService/GetContact", body: "*" } }, I: GetContactRequest, O: GetContactResponse },
    { name: "GetWork", options: { "google.api.http": { post: "/base.persona.PersonaService/GetWork", body: "*" } }, I: GetWorkRequest, O: GetWorkResponse },
    { name: "GetIntrinsic", options: { "google.api.http": { post: "/base.persona.PersonaService/GetIntrinsic", body: "*" } }, I: GetIntrinsicRequest, O: GetIntrinsicResponse },
    { name: "CreateOrUpdateIntrinsicByAccessToken", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateIntrinsicByAccessToken", body: "*" } }, I: CreateOrUpdateIntrinsicByAccessTokenRequest, O: CreateOrUpdateIntrinsicByAccessTokenResponse },
    { name: "CreateOrUpdateContactByAccessToken", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateContactByAccessToken", body: "*" } }, I: CreateOrUpdateContactByAccessTokenRequest, O: CreateOrUpdateContactByAccessTokenResponse },
    { name: "CreateOrUpdateWorkByAccessToken", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateWorkByAccessToken", body: "*" } }, I: CreateOrUpdateWorkByAccessTokenRequest, O: CreateOrUpdateWorkByAccessTokenResponse },
    { name: "CreateOrUpdateSocialByAccessToken", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateSocialByAccessToken", body: "*" } }, I: CreateOrUpdateSocialByAccessTokenRequest, O: CreateOrUpdateSocialByAccessTokenResponse },
    { name: "CreateBodyByAccessToken", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateBodyByAccessToken", body: "*" } }, I: CreateBodyByAccessTokenRequest, O: CreateBodyByAccessTokenResponse },
    { name: "GetAllPersona", options: { "google.api.http": { post: "/base.persona.PersonaService/GetAllPersona", body: "*" } }, I: GetAllPersonaRequest, O: GetAllPersonaResponse },
    { name: "GetInsoleCustomDataList", options: { "google.api.http": { post: "/base.persona.PersonaService/GetInsoleCustomDataList", body: "*" } }, I: GetInsoleCustomDataListRequest, O: GetInsoleCustomDataListResponse },
    { name: "CreateOrUpdateInsoleCustomData", options: { "google.api.http": { post: "/base.persona.PersonaService/CreateOrUpdateInsoleCustomData", body: "*" } }, I: CreateOrUpdateInsoleCustomDataRequest, O: CreateOrUpdateInsoleCustomDataResponse },
    { name: "UpdateInsoleCustomShipping", options: { "google.api.http": { post: "/base.persona.PersonaService/UpdateInsoleCustomShipping", body: "*" } }, I: UpdateInsoleCustomShippingRequest, O: UpdateInsoleCustomShippingResponse },
    { name: "GetAccountsInsoleCustomData", options: { "google.api.http": { post: "/base.persona.PersonaService/GetAccountsInsoleCustomData", body: "*" } }, I: GetAccountsInsoleCustomDataRequest, O: GetAccountsInsoleCustomDataResponse },
    { name: "GetAllInsoleCustomData", options: { "google.api.http": { post: "/base.persona.PersonaService/GetAllInsoleCustomData", body: "*" } }, I: GetAllInsoleCustomDataRequest, O: GetAllInsoleCustomDataResponse },
    { name: "GetSocialAccountIdByRealNameContainsOrDisplayNameContains", options: { "google.api.http": { post: "/base.persona.PersonaService/GetSocialAccountIdByRealNameContainsOrDisplayNameContains", body: "*" } }, I: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, O: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse },
    { name: "GetPresignedPutObjectUrl", options: { "google.api.http": { post: "/base.persona.PersonaService/GetPresignedPutObjectUrl", body: "*" } }, I: GetPresignedPutObjectUrlRequest, O: GetPresignedPutObjectUrlResponse }
]);
